(function($) {
  'use strict';

  const clipboard = {
    dom: function() {
      this.$copy = $('[data-copy]');
    },

    copyAction: function() {
      const _ = this;

      _.$copy.on('click', function(e){
        e.preventDefault();

        if (!navigator.clipboard || !navigator.clipboard.writeText) {
          console.error('Browser does not support navigator.clipboard');
          return;
        }

        const $this = $(this);
        const text = $this.data('copy');
        const $parent = $this.parent();

        navigator.clipboard.writeText(text);

        $this.addClass('copied');
        $parent.addClass('child-copied');

        setTimeout(function() {
          $this.removeClass('copied');
          $parent.removeClass('child-copied');
        }, 3000);
      });
    },

    ready: function() {
      this.dom();
      this.copyAction();
    }
  };

  $(function() { clipboard.ready(); });

})(jQuery);
